<script lang="ts">
  import prompt from '@/store/prompt';
  import {thumbnail} from '@/store';
  import hooksAreaLoadingStore from '@/store/prompt/loading-hooks';
  import type {Video} from '@/types/project';
  import {onMount, createEventDispatcher, onDestroy} from 'svelte';
  import type {ActiveIndex, ClipState, Hook} from '@/types/prompts';
  import LoaderPlus from '../../loader/LoaderPlus.svelte';
  import {ProcessState} from '@/types/common';
  import HookBarTitle from '@/platform-redesign-components/HookBarTitle.svelte';
  import FeatureFlag from '@/platform-redesign-components/FeatureFlag.svelte';
  import {events} from '@/utils/custom-event-names';
  import editorInstance from '@/lib/editor/editor';
  import {createHTMLTextElement} from '@/lib/editor/helpers';
  import {allTextElementsStore} from '@/services/animation/text-loader';
  import {templateFontStore} from '@/services/animation/font-loader';
  import {getInstance} from '@/services/animation';
  import {httpClient} from '@/utils/http-client';

  export let video: Video;
  export let isOpen: boolean = true;
  let items: Array<any> = [];
  let display: boolean = false;
  let loaderMessage: string = 'Retrieving Suggested Texts';
  let unsubscribe: any;

  const dispatch = createEventDispatcher();

  const getQuotes = async () => {
    if ($thumbnail.video)
      httpClient
        .get(`/sermon-summary/${$thumbnail.video.id}/quotes`)
        .then(response => {
          if (response?.data?.quotes) {
            const parser = new DOMParser();
            items = response.data.quotes.map((quote: string) => {
              const document = parser.parseFromString(quote, 'text/html');
              const body = document.querySelector('body');
              return body?.textContent;
            });
          }
          hooksAreaLoadingStore.set(false);
          display = true;
        })
        .catch(error => {
          console.log(error);
          prompt.set({
            status: 'error'
          });
        });
  };

  const getTitles = async () => {
    if ($thumbnail.video)
      httpClient
        .get(`/sermon-summary/${$thumbnail.video.id}/titles`)
        .then(response => {
          console.log(response);
          items = response.data.titles;
          hooksAreaLoadingStore.set(false);
          display = true;
        })
        .catch(error => {
          console.log(error);
          prompt.set({
            status: 'error'
          });
        });
  };

  onMount(async () => {
    hooksAreaLoadingStore.set(true);
    if ($thumbnail.type === 'quote') {
      await getQuotes();
    } else if ($thumbnail.type === 'thumbnail') {
      await getTitles();
    } else {
      await getQuotes();
    }
  });

  const setSelections = (text: string, index: number): any => {
    editorInstance.history.addHistory('Insert Quote/Title');
    if ($thumbnail.type === 'thumbnail') {
      editorInstance.insertTitle(text);
      thumbnail.set({...$thumbnail, title: text});
    } else if ($thumbnail.type === 'quote') {
      editorInstance.insertQuote(text);
      thumbnail.set({...$thumbnail, quote: text});
    }
  };
</script>

<div
  class={`${isOpen == true ? 'w-full' : 'min-w-max'} 
    relative flex h-full flex-shrink-0 flex-col items-center justify-between gap-4 overflow-hidden bg-white  bg-opacity-10
`}
>
  {#if isOpen}
    <div class="flex w-full gap-2 px-6">
      <span class="grow text-base font-bold text-black"
        >Generated {$thumbnail.type === 'quote' ? 'Quotes' : 'Titles'}</span
      >
      <!-- <button on:click={toggleAside} on:keyup={toggleAside}><i class="fa-solid fa-bars"></i></button> -->
    </div>
    {#if $hooksAreaLoadingStore}
      {#if $prompt.status === 'processing'}
        <LoaderPlus status={ProcessState.BUSY} heading={loaderMessage} content="This may take a while" />
      {:else if $prompt.status === 'error'}
        <LoaderPlus status={ProcessState.ERROR} heading="We encountered an error processing your request." />
      {/if}
    {:else if items.length}
      <div class="h-conten flex w-full flex-col gap-8 overflow-y-auto p-6" id="clip-blocks">
        {#each items as hook, id}
          <div
            class={`mx-auto w-full cursor-pointer rounded-xl shadow-md`}
            on:click={setSelections(hook, id)}
            on:keyup={setSelections(hook, id)}
            id="clip-{id}"
          >
            <div class="flex gap-2 rounded-b-md p-10">
              <p class={`text-md font-regular text-zinc- w-full cursor-pointer text-center font-medium`}>
                {hook}
              </p>
            </div>
          </div>
        {/each}
      </div>
    {:else}
      <LoaderPlus status={ProcessState.BUSY} heading="Loading Suggested Texts" />
    {/if}
  {/if}
</div>

<style lang="postcss">
  .vertical {
    writing-mode: vertical-rl;
  }
  .sideways {
    text-orientation: sideways;
  }
  .max-lines {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .h-conten {
    height: calc(100vh - 210px);
    height: calc(100svh - 210px);
  }
</style>
